/**
 * created by panjm on 2020-03-25
 *
 * description：交易订单模块接口地址配置
 *
 */

import pricing from './pricing.js'
import priced from './priced.js'
const config = require('libs/config.js')

const trade = {
	...pricing,
	...priced,
	// 查询全部订单
	getOrderList: role => config.MS_XY_PATH + `/outline/${role}/order`,
	// 查询执行中+未申请终止+未申请暂停中的数据
	getAgreementList: config.MS_XY_PATH + '/outline/buy/order/agreement',
	// 订单详情
	getOrderDetail: (role, orderCode) => config.MS_XY_PATH + `/outline/${role}/order/${orderCode}`,
	// 订单历史明细查看
	getHistoryOrderDetail: (role, recordId) => config.MS_XY_PATH + `/outline/${role}/order/recordDetail/${recordId}`,
	// 订单物资明细
	getOrderGoodsList: (role, orderCode) => config.MS_XY_PATH + `/outline/${role}/order/goods/${orderCode}`,
	// 订单历史查看
	getHistoryOrder: (role, recordId) => config.MS_XY_PATH + `/outline/${role}/order/history/${recordId}`,
	// 协议物资信息查询
	getAgreementInfo: (pkid, orderType) => config.MS_XY_PATH + `/outline/buy/order/agreement/${pkid}/${orderType}`,
	// 订单统计查询
	getOrderCount: role => config.MS_XY_PATH + `/outline/${role}/order/count`,
	// 买方提醒对方确认订单
	buyRemind: orderCode => config.MS_XY_PATH + `/outline/buy/order/remindConfirm/${orderCode}`,
	// 卖方提醒对方确认订单
	sellRemind: orderCode => config.MS_XY_PATH + `/outline/sell/order/remind/${orderCode}`,
	// 获取复制订单
	getCopyOrder: orderCode => config.MS_XY_PATH + `/outline/buy/order/copy/${orderCode}`,
	// 获取订单变更详情
	getPriceUpdateDetail: (role, recordId) => config.MS_XY_PATH + `/outline/${role}/order/agreechanged/recordMx/${recordId}`
}

export default trade



// WEBPACK FOOTER //
// ./src/api/trade/index.js